export default __webpack_public_path__ + "static/02-34cd9baeb78971ad4c8e0039881f38a6.jpg";